import { render } from "./ExportTrim.vue?vue&type=template&id=0bf07dbc&scoped=true"
import script from "./ExportTrim.vue?vue&type=script&lang=js"
export * from "./ExportTrim.vue?vue&type=script&lang=js"

import "./ExportTrim.vue?vue&type=style&index=0&id=0bf07dbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf07dbc"]])

export default __exports__